import { render, staticRenderFns } from "./LegalDocumentFormFilesBox.vue?vue&type=template&id=283d9432&scoped=true&"
import script from "./LegalDocumentFormFilesBox.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentFormFilesBox.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentFormFilesBox.vue?vue&type=style&index=0&id=283d9432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d9432",
  null
  
)

export default component.exports